import {
  EcommerceTaxClassesAction,
  LOAD_ECOMMERCE_TAX_CLASSES,
  LOAD_ECOMMERCE_TAX_CLASSES_FAIL,
  LOAD_ECOMMERCE_TAX_CLASSES_SUCCESS,
  LoadEcommerceTaxClasses,
  LoadEcommerceTaxClassesFail,
  LoadEcommerceTaxClassesSuccess,
} from "../actions";

export interface IEcommerceTaxClassesEntityState {
  data: any;
  filterData: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceTaxClassesState {
  entities: { [websiteId: number]: IEcommerceTaxClassesEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceTaxClassesState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceTaxClassesState = initialState, action: EcommerceTaxClassesAction): IEcommerceTaxClassesState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_TAX_CLASSES:
      payload = (<LoadEcommerceTaxClasses>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_TAX_CLASSES_SUCCESS:
      payload = (<LoadEcommerceTaxClassesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            filterData: payload.filterData,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_TAX_CLASSES_FAIL:
      payload = (<LoadEcommerceTaxClassesFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
